// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"399":"4c815ee6","456":"1c81167d"}[chunkId] + ".chunk.js";
};